const EventEmitter = require('events');

import {newReq} from "@/core/request";

export class User extends EventEmitter {
    constructor(obj) {
        super();
        this.siteIds = [];
        this.disabledSiteIds = [];
        this.name = null;
        this.username = null;
        this.password = null;
        this.totp = {enabled: false,}
        this.adminSiteId = null;
        Object.assign(this, obj)
        if (this.lastLogin && typeof this.lastLogin == "string")
            this.lastLogin = new Date(this.lastLogin)
    }

    update(...keys) {
        const updateObj = JSON.parse(JSON.stringify(this))
        if (keys.length)
            Object.keys(this).forEach(key => {
                if (!keys.includes(key))
                    delete updateObj[key];
            })
        return newReq('POST', `users/update`, {...updateObj, _id: this._id})
    }
    // updatePassword() {
    //     return newReq('POST', `sysAdmins/password`, {_id: this._id, password: this.password})
    // }
    create() {
        return newReq('POST', `users/create`, {
            name: this.name,
            disabled: this.disabled,
            username: this.username,
            password: this.password,
            adminSiteId: this.adminSiteId,
            siteIds: this.siteIds,
            disabledSiteIds: []
        })
    }
    // delete() {
    //     return newReq('DELETE', `sysAdmins/delete`, {_id: this._id})
    // }
}